export default __webpack_public_path__ + "static/media/join-remind.c9964616.png";